import { computed } from 'mobx';
import { APICallStore, APICall, APICallResponse, APICallState } from './api_call_store';

type ResponseFilter<T extends APICall, R> = (response: APICallResponse<T>) => R;

interface DetailStoreOpts<T extends APICall, R> {
    filter: ResponseFilter<T, R>;
    fnName: string;
}

export class DetailStore<T extends APICall, R> {
    private apiCallStore: APICallStore<T>;

    constructor(apiCall: T, private readonly opts: DetailStoreOpts<T, R>) {
        this.apiCallStore = new APICallStore(apiCall, opts.fnName);
    }

    @computed
    public get state() {
        return this.apiCallStore.state;
    }

    @computed
    public get lastError() {
        return this.apiCallStore.lastError;
    }

    @computed
    public get result(): R | undefined {
        const response = this.apiCallStore.response;
        if (response) {
            return this.opts.filter(response);
        }
        return undefined;
    }

    @computed
    public get loading() {
        return this.state === APICallState.loading;
    }

    public fetch(...args: Parameters<T>) {
        return this.apiCallStore.fetch(...args);
    }

    public refresh() {
        return this.apiCallStore.refresh();
    }
}
